var _rect, _rect2, _rect3, _rect4, _g, _rect5, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgNavMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 56,
    preserveAspectRatio: "none",
    viewBox: "0 0 360 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_188_137899",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 360,
    height: 56
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 56,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_188_137899)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -0.222656,
    y: -108,
    width: 360.444,
    height: 203,
    fill: "url(#paint0_linear_188_137899)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_188_137899",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -108,
    width: 362,
    height: 203
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -0.222656,
    y: -108,
    width: 360.444,
    height: 203,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_188_137899)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 373,
    height: 662.293,
    transform: "matrix(0 1 1 0 -91.4023 -130.607)",
    fill: "url(#paint1_linear_188_137899)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M235.429 -130.607C235.429 -130.607 218.096 -31.5202 164.327 63.9562C110.558 159.433 10.7695 242.393 10.7695 242.393L570.89 242.393V-130.607L235.429 -130.607Z",
    fill: "url(#paint2_linear_188_137899)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_137899",
    x1: -0.222656,
    y1: -108,
    x2: 360.129,
    y2: 95.1628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_188_137899",
    x1: 214.539,
    y1: 429.092,
    x2: -382.546,
    y2: -75.4699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_188_137899",
    x1: -15.7807,
    y1: 11.7105,
    x2: 599.598,
    y2: 127.307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A0EC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03DA8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNavMobile);
export default __webpack_public_path__ + "static/media/bg-nav-mobile.295d3e734331cde26c5dde538af6fc3f.svg";
export { ForwardRef as ReactComponent };